@if (isVisible() && breadcrumbs().length > 0) {
  <!-- @ Títol Pàgina -->
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between pb-6">
    <h2 class="text-xl font-semibold font-title text-gray-800 dark:text-white/90">
      {{ title() }}
    </h2>

    <!-- @ Breadcrumb -->
    <nav>
      <ol class="flex flex-wrap items-center gap-1.5">
        @for (breadcrumb of breadcrumbs(); track breadcrumb.url; let first = $first; let last = $last) {
          <li
              class="flex items-center gap-1.5 text-sm"
              [class.text-gray-800]="last"
              [class.dark:text-white/90]="last"
              [class.text-gray-500]="!last">
            
            @if (!first) {
              <span class="text-gray-500 dark:text-gray-400">
                <svg
                  class="stroke-current"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.83333 12.6665L10 8.49984L5.83333 4.33317"
                    stroke="currentColor"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            }

            @if (!last) {
              <a [routerLink]="breadcrumb.url" class="hover:text-brand-500">
                {{ breadcrumb.label }}
              </a>
            } @else {
              <span class="text-gray-800 dark:text-white/90">{{ breadcrumb.label }}</span>
            }
          </li>
        }
      </ol>
    </nav>
  </div>
}